import BasicElement from './src/components/BasicElement/index';
import Button from './src/components/Button/index';
import Carousel from './src/components/Carousel/index';
import CarouselItem from './src/components/CarouselItem/index';
import GTMHandler from './src/components/GTMHandler/index';
import Icon from './src/components/Icon/index';
import Image from './src/components/Image/index';
import Loading from './src/components/Loading/index';
import Modal from './src/components/Modal/index';
import Nav from './src/components/Nav/index';
import NavItem from './src/components/Nav/NavItem';
import Offcanvas from './src/components/Offcanvas/Offcanvas';
import OffcanvasBackButton from './src/components/Offcanvas/OffcanvasBackButton';
import OffcanvasButton from './src/components/Offcanvas/OffcanvasButton';
import RawHTML from './src/components/RawHTML/index';
import Tab from './src/components/Tab/index';
import Tabs from './src/components/Tabs/index';
import VHSAccordion from './src/components/VHSAccordion/index';
import VHSAlertBar from './src/components/VHSAlertBar/index';
import VHSAlternatingTextAndImages from './src/components/VHSAlternatingTextAndImages/index';
import VHSAlumni from './src/components/VHSAlumni/index';
import VHSBlockQuote from './src/components/VHSBlockQuote/index';
import VHSBlogRoll from './src/components/VHSBlogRoll/index';
import VHSBlogRollFilterBar from './src/components/VHSBlogRoll/VHSBlogRollFilterBar';
import VHSBlogRollPagination from './src/components/VHSBlogRoll/VHSBlogRollPagination';
import VHSBlogRollTile from './src/components/VHSBlogRoll/VHSBlogRollTile';
import VHSBreadcrumb from './src/components/VHSBreadcrumb/index';
import VHSButtonSamples from './src/components/VHSButtonSamples/index';
import VHSCallToActionBar from './src/components/VHSCallToActionBar/index';
import VHSCallToActionBarInline from './src/components/VHSCallToActionBarInline/index';
import VHSCarousel from './src/components/VHSCarousel/index';
import VHSCart from './src/components/VHSCart/index';
import VHSNewRegistration from './src/components/VHSCart/VHSNewRegistration';
import VHSRegistrationModal from './src/components/VHSCart/VHSRegistrationModal';
import VHSChecklist from './src/components/VHSChecklist/index';
import VHSContainer from './src/components/VHSContainer/index';
import VHSCourses from './src/components/VHSCourses/index';
import VHSFAQs from './src/components/VHSFAQs/index';
import VHSFooter from './src/components/VHSFooter/index';
import VHSFunctions from './src/components/VHSFunctions/index';
import VHSHeader from './src/components/VHSHeader/index';
import VHSHero from './src/components/VHSHero/index';
import VHSIconSamples from './src/components/VHSIconSamples/index';
import VHSImageBar from './src/components/VHSImageBar/index';
import VHSLogoBar from './src/components/VHSLogoBar/index';
import VHSMediaModal from './src/components/VHSMediaModal/index';
import VHSMegaTabs from './src/components/VHSMegaTabs/index';
import VHSMegaTiles from './src/components/VHSMegaTiles/index';
import VHSProcess from './src/components/VHSProcess/index';
import VHSQuote from './src/components/VHSQuote/index';
import VHSRecentPosts from './src/components/VHSRecentPosts/index';
import VHSSearch from './src/components/VHSSearch/index';
import VHSSignup from './src/components/VHSSignup/index';
import VHSSpacer from './src/components/VHSSpacer/index';
import VHSStat from './src/components/VHSStat/index';
import VHSStats from './src/components/VHSStats/index';
import VHSSummary from './src/components/VHSSummary/index';
import VHSTestimonials from './src/components/VHSTestimonials/index';
import VHSTiles from './src/components/VHSTiles/index';
import VHSTip from './src/components/VHSTip/index';
import VHSTypographySamples from './src/components/VHSTypographySamples/index';
import VHSVideo from './src/components/VHSVideo/index';

const components = {
	BasicElement,
	Button,
	Carousel,
	CarouselItem,
	GTMHandler,
	Icon,
	Image,
	Loading,
	Modal,
	Nav,
	NavItem,
	Offcanvas,
	OffcanvasBackButton,
	OffcanvasButton,
	RawHTML,
	Tab,
	Tabs,
	VHSAccordion,
	VHSAlertBar,
	VHSAlternatingTextAndImages,
	VHSAlumni,
	VHSBlockQuote,
	VHSBlogRoll,
	VHSBlogRollFilterBar,
	VHSBlogRollPagination,
	VHSBlogRollTile,
	VHSBreadcrumb,
	VHSButtonSamples,
	VHSCallToActionBar,
	VHSCallToActionBarInline,
	VHSCarousel,
	VHSCart,
	VHSNewRegistration,
	VHSRegistrationModal,
	VHSChecklist,
	VHSContainer,
	VHSCourses,
	VHSFAQs,
	VHSFooter,
	VHSFunctions,
	VHSHeader,
	VHSHero,
	VHSIconSamples,
	VHSImageBar,
	VHSLogoBar,
	VHSMediaModal,
	VHSMegaTabs,
	VHSMegaTiles,
	VHSProcess,
	VHSQuote,
	VHSRecentPosts,
	VHSSearch,
	VHSSignup,
	VHSSpacer,
	VHSStat,
	VHSStats,
	VHSSummary,
	VHSTestimonials,
	VHSTiles,
	VHSTip,
	VHSTypographySamples,
	VHSVideo
};

export default components;
